
export default class MainMenu {
    
    static get selector() {
        return '.header__categoryList';
    }

    constructor(el) {
        return;
        this.el = el;
        this.items = this.getItems();
        this.setEvents();
    }

    getItems() {
        let elements = this.el.querySelectorAll('.header__categoryItem');
        let items = [];
        Array.from(elements).forEach( element =>{
            let item = {};
            item.el = element;
            item.isActive = item.el.classList.contains('header__categoryItem--active');
            items.push(item);
        }); 
        return items;
    }

    active(item) {
        if(item.isActive) return;
        item.el.classList.add('header__categoryItem--active');
        item.isActive = true;
    }

    goWithParams(url) {
        window.dispatchEvent( new CustomEvent('vegout-submit-url', {
            detail: {
              url: url
            }
        }));
    }

    desactive(item) {
        if(!item.isActive) return;
        item.el.classList.remove('header__categoryItem--active');
        item.isActive = false;
    }

    desactiveAll(item) {
        this.items.forEach(item => {
            this.desactive(item);
        });
    }

    setEvents() {
        window.addEventListener('vegout-menu-update', this.e_update_menu.bind(this));
        this.items.forEach( item => {
            item.el.addEventListener('click', (e) => { this.e_clickItem(e, item); });
        });
    }

    e_clickItem( e , item) {
        e.preventDefault();
        this.goWithParams(item.el.getAttribute('href'));
    }

    e_update_menu( e ) {
        this.desactiveAll();
        this.items.forEach(item => {
            if (item.el.href === location.protocol + '//' + location.host + location.pathname) this.active(item);
        });
    }

}